export default __webpack_public_path__ + "static/learnplus3-ff1597d89a499588fb36d368c0a38676.svg";